import { useMultipleChoiceExam } from '../../../../../hooks/useMultipleChoiceExam';
import CollectingData from '../../../../../containers/CollectingData';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import ExamDetail from '../../components/ExamDetail';
import ExamBox from '../../components/ExamBox';
import styles from './style.module.scss';
import Webcam from 'react-webcam';

function Exam() {
    const {
        next,
        hours,
        examId,
        action,
        userId,
        counter,
        minutes,
        seconds,
        jobTitle,
        exitExam,
        showHelp,
        webcamRef,
        startExam,
        enableNext,
        examDetail,
        setShowHelp,
        isExamEnded,
        isExamStarted,
        isLastQuestion,
        selectedOption,
        isCameraActive,
        currentQuestion,
        onSelectFromHelp,
        setSelectedOption,
        setIsCameraActive,
        totalQuestionsCount,
        currentQuestionText,
        isFetchingQuestions,
        currentQuestionOptions,
    } = useMultipleChoiceExam();

    return (
        <MotionWrapper className={styles.wrapper}>
            {!isExamEnded && (<>
                {isExamStarted ? <ExamBox
                    next={next}
                    userId={userId}
                    examId={examId}
                    counter={counter}
                    showHelp={showHelp}
                    jobTitle={jobTitle}
                    enableNext={enableNext}
                    setShowHelp={setShowHelp}
                    question={currentQuestionText}
                    selectedOption={selectedOption}
                    isLastQuestion={isLastQuestion}
                    currentQuestion={currentQuestion}
                    onSelectFromHelp={onSelectFromHelp}
                    totalQuestions={totalQuestionsCount}
                    setSelectedOption={setSelectedOption}
                    questionOptions={currentQuestionOptions}
                    isFetchingQuestions={isFetchingQuestions}
                /> :
                    <ExamDetail
                        action={action}
                        detail={examDetail}
                        startExam={startExam}
                        isCameraActive={isCameraActive}
                        isFetchingQuestions={isFetchingQuestions}
                    />}
                <div className={styles.stream}>
                    <div className={styles.stream_video}>
                        <Webcam
                            audio
                            muted
                            ref={webcamRef}
                            onUserMedia={e => setIsCameraActive(e.active)}
                            onUserMediaError={() => setIsCameraActive(false)}
                        />
                    </div>
                    <div className={styles.stream_detail}>
                        <span className={styles.stream_detail_live}></span>
                        <span className={styles.stream_detail_countdown}>{`${hours}:${minutes}:${seconds}`}</span>
                    </div>
                    {isExamStarted && counter < 6 && <div className={styles.stream_countdown}>
                        <CountdownCircleTimer
                            isPlaying
                            size={80}
                            duration={5}
                            strokeWidth={6}
                            colorsTime={[5, 2, 0]}
                            colors={['#004777', '#A30000', '#C4314B']}
                        >
                            {({ remainingTime }) => remainingTime}
                        </CountdownCircleTimer>
                    </div>}
                    <div className={styles.stream_exit} onClick={exitExam}>
                        <span>Exit exam</span>
                    </div>
                </div>
            </>)}
            {isExamEnded && <CollectingData
                progress={100}
                description='Please remain on this page while we collect your data.'
            />}
        </MotionWrapper>
    )
};

export default Exam;
